import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

console.log('[walking-sun] script loaded');

document.addEventListener('DOMContentLoaded', () => {
	console.log('[walking-sun] DOMContentLoaded fired');

	const container = document.getElementById('walking-sun');
	console.log('[walking-sun] container:', container);

	const section = document.getElementById('hero');
	console.log('[walking-sun] section:', section);

	if (!container || !section) {
		console.warn('[walking-sun] missing container or section, bailing');
		return;
	}

	const frames = [
		'/images/walking-sun/sun-walk-1.svg',
		'/images/walking-sun/sun-walk-2.svg',
		'/images/walking-sun/sun-walk-3.svg',
		'/images/walking-sun/sun-walk-4.svg',
		'/images/walking-sun/sun-walk-5.svg',
	];

	const LOOPS = 3;
	const totalFrames = frames.length * LOOPS;

	container.innerHTML = `<img id="walking-sun-frame" src="${frames[0]}" class="w-full h-auto" alt="Walking sun animation">`;
	const img = document.getElementById('walking-sun-frame');
	console.log('[walking-sun] replaced with img, src:', img.src);

	frames.forEach(src => { const i = new Image(); i.src = src; });

	window.addEventListener('load', () => {
		console.log('[walking-sun] load fired, setting up ScrollTrigger');
		ScrollTrigger.create({
			trigger: section,
			start: 'top top',
			end: 'bottom bottom',
			scrub: true,
			onUpdate: (self) => {
				const frameIndex = Math.min(
					Math.floor(self.progress * totalFrames),
					totalFrames - 1
				);
				const src = frames[frameIndex % frames.length];
				if (img.src !== src) img.src = src;
			},
		});
		console.log('[walking-sun] ScrollTrigger created');
	});
});
